import React from 'react';
import { PERMISSION } from 'pages/Script/utils/constants';

const ScriptAdd = React.lazy(() => import('pages/Script/pages/ScriptAdd'));
const ScriptPage = React.lazy(() => import('pages/Script/pages/ScriptPage'));
const ScriptEdit = React.lazy(() => import('pages/Script/pages/ScriptEdit'));
const DetailPage = React.lazy(() => import('pages/Script/pages/ScriptDetail'));

const SciptRoute = [
  {
    path: '/script',
    exact: true,
    name: 'Danh sách kịch bản',
    function: PERMISSION.VIEW,
    component: ScriptPage,
  },
  {
    path: '/script/add',
    exact: true,
    name: 'Thêm mới kịch bản',
    function: PERMISSION.ADD,
    component: ScriptAdd,
  },
  {
    path: '/script/edit/:id',
    exact: true,
    name: 'Chỉnh sửa kịch bản',
    function: PERMISSION.EDIT,
    component: ScriptEdit,
  },
  {
    path: '/script/detail/:id',
    exact: true,
    name: 'Chi tiết kịch bản',
    function: PERMISSION.VIEW,
    component: DetailPage,
  },
];

export default SciptRoute;
